import { render, staticRenderFns } from "./CreateProjectInformation.vue?vue&type=template&id=08f36502&scoped=true&"
import script from "./CreateProjectInformation.vue?vue&type=script&lang=js&"
export * from "./CreateProjectInformation.vue?vue&type=script&lang=js&"
import style0 from "./CreateProjectInformation.vue?vue&type=style&index=0&id=08f36502&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f36502",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCardText,VChip,VCol,VFileInput,VImg,VRow,VTextField,VTextarea})
